/**
 * Derive Client Tag → Accounting mapping list from GET /tag-mappings response.
 */
import {
  extractTagMappingsArray,
  normalizeTagMappingRow,
} from "../../utils/tagMappingApiNormalize";

const CLIENT = "CLIENT_TO_ACCOUNTING";

export function getTabMappingsListFromApiData(data) {
  const rows = extractTagMappingsArray(data?.data ?? data);
  return rows.map((r) => normalizeTagMappingRow(r, CLIENT)).filter(Boolean);
}

export function getTabMappingsMetaFromApiData(data) {
  return data?.data?.meta ?? data?.meta ?? null;
}
